import { useTranslation } from "react-i18next";

const ctaBg =
  "https://readdy.ai/api/search-image?query=Warm%20modern%20residential%20interior%20at%20dusk%20with%20soft%20ambient%20lighting%2C%20contemporary%20steel%20frame%20architecture%20visible%20through%20large%20windows%2C%20cozy%20living%20space%20with%20premium%20finishes%2C%20warm%20golden%20hour%20atmosphere%2C%20architectural%20photography%2C%20cream%20and%20charcoal%20tones%2C%20editorial%20quality%20with%20soft%20dark%20background%2C%20inviting%20home%20interior%20scene%2C%20%20%20&width=1600&height=700&seq=15&orientation=landscape";

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={ctaBg} alt="溫暖現代住宅室內" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-graphite/85 via-graphite/70 to-graphite/85" />
      </div>

      <div className="relative z-10 section-padding">
        <div className="container-main text-center max-w-3xl mx-auto">
          <span className="tag-label mb-6 inline-block">{t("about.final.label")}</span>
          <h2 className="text-white mb-4">{t("about.final.title")}</h2>
          <p className="text-cream/85 mb-10 max-w-2xl mx-auto">{t("about.final.desc")}</p>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary gap-2 inline-flex"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            {t("about.final.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}